import { CartItems, FeesAndDiscounts, FiberDiscounts, Maybe } from '@buy-viasat/types/build/bv';

export type CartState = {
  cartId: Maybe<string>;
  cartItems: Maybe<CartItems>;
  promoTotal: number;
  lease: Maybe<number>;
  monthlyTotalWithPromo: Maybe<number>;
  monthlyTotalWithoutPromo: Maybe<number>;
  onetimeTotalWithPromo: Maybe<number>;
  onetimeTotalWithoutPromo: Maybe<number>;
  onetimeDiscount: Maybe<number>;
  isCartError: boolean;
  isCartClosingOfferLoading: Maybe<boolean>;
  oneTimeLeaseFee: Maybe<number>;
  leaseFeeShortName: Maybe<string>;
  optionalServicesEditMode: boolean;
  feesAndDiscounts?: FeesAndDiscounts[];
  fiberDiscounts?: FiberDiscounts[] | null;
  addonToBeRemoved?: Maybe<string>;
};

export const initialCartState: CartState = {
  cartId: null,
  cartItems: null,
  promoTotal: 0,
  lease: null,
  monthlyTotalWithPromo: null,
  monthlyTotalWithoutPromo: null,
  onetimeTotalWithPromo: null,
  onetimeTotalWithoutPromo: null,
  onetimeDiscount: null,
  isCartError: false,
  isCartClosingOfferLoading: null,
  oneTimeLeaseFee: null,
  leaseFeeShortName: null,
  optionalServicesEditMode: false,
  feesAndDiscounts: [],
  fiberDiscounts: null,
  addonToBeRemoved: null,
};

export type ToastConfig = {
  translateKey?: string;
  translateOptions?: {};
  variant?: 'success';
};
